"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataLog = exports.QueueItem = exports.QUEUE_ITEM_TYPES = void 0;
const Common_1 = require("./Common");
const Base_1 = require("./Base");
const index_1 = require("../index");
var QUEUE_ITEM_TYPES;
(function (QUEUE_ITEM_TYPES) {
    QUEUE_ITEM_TYPES["BIGQUERY"] = "BIGQUERY";
    QUEUE_ITEM_TYPES["FOLLOWUP"] = "FOLLOWUP";
    QUEUE_ITEM_TYPES["MERGE"] = "merge";
    QUEUE_ITEM_TYPES["MARKETPLACE_SUBSCRIPTION"] = "sub";
    QUEUE_ITEM_TYPES["AVIANIS_TRIP"] = "avianis-trip";
    QUEUE_ITEM_TYPES["AVIANIS_QUOTE"] = "avianis-quote";
    QUEUE_ITEM_TYPES["DEAL_UPDATE"] = "laro-deal-update";
    QUEUE_ITEM_TYPES["MICROSOFT_SUBSCRIPTION"] = "microsoft";
    QUEUE_ITEM_TYPES["IMPORT"] = "import";
    QUEUE_ITEM_TYPES["RCRT_EVENT_CHECK"] = "rcrt-event-check";
    QUEUE_ITEM_TYPES["RCRT_ADD_EVENT"] = "rcrt-add-event";
    QUEUE_ITEM_TYPES["RCRT_ADD_TEAMS"] = "rcrt-add-teams";
    // RCRT_ADD_GAMES = 'rcrt-add-games',
    QUEUE_ITEM_TYPES["RCRT_ADD_SCOUTS"] = "rcrt-add-scouts";
    QUEUE_ITEM_TYPES["RCRT_ADD_STAFF"] = "rcrt-add-staff";
    QUEUE_ITEM_TYPES["RCRT_ADD_STAFF_SCRAPE"] = "rcrt-add-staff-scrape";
    QUEUE_ITEM_TYPES["RCRT_ADD_STAFF_AI"] = "rcrt-add-staff-ai";
    QUEUE_ITEM_TYPES["RCRT_ADD_SEASON"] = "rcrt-add-season";
    QUEUE_ITEM_TYPES["RCRT_ADD_SEASON_SCRAPE"] = "rcrt-add-season-scrape";
    QUEUE_ITEM_TYPES["RCRT_ADD_SCHOOL"] = "rcrt-add-school";
    QUEUE_ITEM_TYPES["RCRT_ADD_ROSTER"] = "rcrt-add-roster";
    QUEUE_ITEM_TYPES["RCRT_ADD_ROSTER_SCRAPE"] = "rcrt-add-roster-scrape";
    QUEUE_ITEM_TYPES["RCRT_ADD_SPORT"] = "rcrt-add-sport";
    QUEUE_ITEM_TYPES["DOWNLOAD_URL"] = "download-url";
    // UNREAD_COUNTS = 'unread-counts',
    QUEUE_ITEM_TYPES["AI_NOTIFICATION_SEARCH"] = "ai-notification-search";
    QUEUE_ITEM_TYPES["DELETE_CLIENT"] = "delete-client";
    QUEUE_ITEM_TYPES["NONE"] = "";
})(QUEUE_ITEM_TYPES || (exports.QUEUE_ITEM_TYPES = QUEUE_ITEM_TYPES = {}));
class QueueItem extends Base_1.Base {
    type = QUEUE_ITEM_TYPES.NONE;
    action = '';
    path = '';
    class_name = '';
    data = {};
    creator = null;
    followers = [];
    agents = [];
    roles = [];
    constructor(data, olMap) {
        super('queue_items', 36);
        (0, Common_1.setObjectProperties)(this, data, olMap, QueueItem);
        if (this.data?.object) {
            this.data.object = (0, index_1.loadObject)(this.data.object, { olm: olMap || index_1.olm });
            this.data.contact = (0, index_1.loadObject)(this.data.contact, { olm: olMap || index_1.olm });
            if (this.data.object && this.data.contact && !(this.data.object instanceof index_1.Contact)) {
                this.data.object.contact = this.data.contact;
            }
        }
    }
    async loadAll(opts, stack, p) {
        await super.loadAll(opts, stack, p);
        if (this.type === QUEUE_ITEM_TYPES.FOLLOWUP) {
            this.data = new index_1.ThreadMessage(this.data);
            await this.data.loadAll(opts, stack, p);
        }
    }
    toString() {
        return `QueueItem: ${this.type}: ${this.action}: ${this.path}`;
    }
    toJSON() {
        let r = super.toJSON();
        if (this.data?.toJSON) {
            r.data = this.data.toJSON();
        }
        return r;
    }
    async save(parent) {
        if (parent?._settings?.projectId) {
            if (!this.id) {
                this.setID();
            }
            this._docRef = parent.doc(`${this._type}/${this.id}`);
            return super.save();
        }
        else {
            return super.save(parent);
        }
    }
}
exports.QueueItem = QueueItem;
index_1.olm.queue_items = (ref, map) => {
    return new QueueItem(ref, map);
};
class DataLog extends Base_1.Base {
    action = '';
    result = null;
    success = null;
    details = '';
    constructor(data, olMap) {
        super('data_logs', 12);
        (0, Common_1.setObjectProperties)(this, data, olMap || index_1.olm, DataLog);
    }
}
exports.DataLog = DataLog;
index_1.olm.data_logs = (ref, map) => {
    return new DataLog(ref, map);
};
